<script>
  /**
 *
 *
 */

  /*                */
  let { variation } = $props();

  const { numberOfReviews, averageRatingRounded } = variation;
  const MAX_RATING_ICONS = 5;

  const ratingFilledCount = Math.trunc(averageRatingRounded);
  const ratingHalfCount = (averageRatingRounded - ratingFilledCount) * 2;
  const ratingEmptyCount = MAX_RATING_ICONS - (ratingFilledCount + ratingHalfCount);
</script>

{#if numberOfReviews && averageRatingRounded}
  <div class="reco_aos_product_card__rating">
    <div class="reco_aos_product_card__rating__icon_container">
      <!--eslint-disable-next-line no-unused-vars-->
      {#each Array(ratingFilledCount) as _}
        <oc-icon-v1 class="reco_aos_product_card__rating_star" type="rating-filled" size="50"
        ></oc-icon-v1>
      {/each}
      <!--eslint-disable-next-line no-unused-vars-->
      {#each Array(ratingHalfCount) as _}
        <oc-icon-v1 class="reco_aos_product_card__rating_star" type="rating-half" size="50"
        ></oc-icon-v1>
      {/each}
      <!--eslint-disable-next-line no-unused-vars-->
      {#each Array(ratingEmptyCount) as _}
        <oc-icon-v1 class="reco_aos_product_card__rating_star" type="rating-empty" size="50"
        ></oc-icon-v1>
      {/each}
    </div>
    <div
      class="reco_aos_product_card__rating__reviews_number"
      data-testid="reco_aos_product_card__number_of_reviews">
      {numberOfReviews}
    </div>
  </div>
{/if}

<style lang="scss">
  .reco_aos_product_card__rating__reviews_number {
    margin-left: 3px;
    color: var(--oc-semantic-color-text-secondary);
    font: var(--oc-semantic-font-copy-75);
  }
  .reco_aos_product_card__rating {
    display: flex;
    align-items: center;
    padding-top: 8px;
  }
  .reco_aos_product_card__rating__icon_container {
    display: flex;

    .reco_aos_product_card__rating_star {
      margin-right: 2px;
    }
  }
</style>
